export const THEME = {
  SAAREMAA: 'saaremaa',
  KIHNU: 'kihnu',
  GAVDOS: 'gavdos',
  LIINILAEVAD: 'liinilaevad',
  DEMO: 'demo',
}
